import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "inline-flex justify-center items-center self-stretch font-mono w-6 py-1 bg-slate-200 uppercase font-mono"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'Position',
  props: {
    position: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.position ?? '-'), 1)])]);
    };
  }
});